const ATTENDANCE_TIME_PATTERN = /^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d)?$/

/** Empty attendance-edit times remain optional; non-empty values must be valid 24-hour times. */
export const isValidOptionalAttendanceTime = (value: string): boolean =>
  value === '' || ATTENDANCE_TIME_PATTERN.test(value)

/** Keep valid existing HH:mm and HH:mm:ss values usable by the native time input. */
export const toAttendanceTimeInputValue = (value?: string | null): string => {
  const normalized = value?.trim() ?? ''
  return ATTENDANCE_TIME_PATTERN.test(normalized) ? normalized : ''
}
